export type UserRole = unknown; // TBD

// List of permissions specific to the project
export type UserPermission =
	| 'EDIT_GLOBAL_MASTER_CONTENT'
	| 'MAPPING'
	| 'SECURITY' // permissions page
	| 'EDIT_GLOBAL_MASTER_CONTENT_SECURITY'
	| 'MAPPING_SECURITY'
	| 'BLACKBOX';

/** project permissions constant
 * @type {UserPermission[]}
 */
export const projectPermissions: UserPermission[] = [
	'EDIT_GLOBAL_MASTER_CONTENT',
	'MAPPING',
	'SECURITY',
	'EDIT_GLOBAL_MASTER_CONTENT_SECURITY',
	'MAPPING_SECURITY',
	'BLACKBOX',
];
